<template>
    <div class="main-content__wizzard">
        <div class="wizzard__content">
            <h2 class="wizzard__step-title" v-translate>
                Choose your perfect date
            </h2>
            <div class="message message--with-icon message--info" v-translate>
                Note that you can always reschedule your activity later.
            </div>
            <form class="form">
                <div v-if="activity.date == ''">
                    <div class="your-dates__date">
                        <div class="your-dates__date-title" v-translate>
                            When will you <strong>Do It?</strong>
                        </div>
                        <div class="your-dates__category">
                            <span class="main-category-icon" :class="iconClass"></span> {{subcategoryName}}
                        </div>
                        <div class="your-dates__date-strength">
                            <translate>Strength of your day</translate>:
                            <div class="date-strength date-strength--good">?</div>
                        </div>
                    </div>
                    <button @click="chooseDate()" class="button button--gray" type="button" v-translate>Choose date </button>
                </div>
                <div v-if="activity.date != ''">
                    <activity-date-display :activity="activity" :icon-class="iconClass" :subcategory-name="subcategoryName"/>
                <button @click="chooseDate()" class="button button--gray button--small" type="button" v-translate>Change date</button>
                </div>
                <div class="form__action-buttons">
                    <a href="javascript:;" class="button button--primary" @click="submit()" v-translate>Next step</a>
                    <a href="javascript:;" class="button button--transparent" @click="$emit('advance','step-2')" v-translate>Previous step</a>
                </div>
            </form>
        </div>
        <div class="wizzard__tips">
            <h2 v-translate>Quick tips</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid aperiam eligendi eos facilis
                illo, ipsa iste, laboriosam laudantium porro qui similique, sit suscipit tempore vero voluptate.
                Eaque impedit porro quae.</p>
            <p>Ab adipisci deserunt eius expedita explicabo, facilis, in mollitia natus provident quam quisquam,
                quo reiciendis repudiandae temporibus vel velit voluptate. Adipisci ducimus eligendi itaque,
                nesciunt pariatur perferendis rerum totam voluptates.</p>
            <p>Assumenda consequatur eaque est expedita hic labore maiores, molestias odio perferendis repellat
                soluta tempore voluptatem. Facilis in inventore itaque neque repellat unde ut. A animi
                architecto consequatur consequuntur quibusdam, quos.</p>
        </div>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators';
    import {mapActions} from "vuex";
    import ChooseDate from "../../views/popups/ChooseDate";
    import ActivityDateDisplay from "../../views/ActivityDateDisplay";
    import ActivityClass from "../../mixins/ActivityClass";

    export default {
        name: 'plan-activity-step-three',
        mixins: [ActivityClass],
        components: {ActivityDateDisplay},
        data() {
            return {
                activity: {},
                choose_date: ChooseDate
            }
        },
        props: {
            parent_activity: {},
        },
        beforeMount: function() {
            this.activity = this.parent_activity
        },
        methods: {
            submit: function() {
                if (this.activity.date!='') {
                    this.$emit('advance', 'step-4')
                }
            },
            ...mapActions(['openPopup', 'setPopupPayload']),
            chooseDate: function() {
                this.setPopupPayload(this.activity)
                this.openPopup(ChooseDate)
            }
        },
        validations: {
            activity: {
                name: {required},
                description: {},
                category: {required},
                subcategory: {required}
            }
        }
    }
</script>